// extracted by mini-css-extract-plugin
export default {"heroText":"Hero_heroText__aLFfU","secondaryText":"Hero_secondaryText__fmQ8m","heroArea":"Hero_heroArea__5ayD0"};